import type { Paginated } from '@/interface/Paginate';
import type { AssetOpportunity } from '@/modules/Asset/interface/Opportunity';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getAssetsOpportunities = async (
  params?: GetAssetsOpportunitiesParams
) => {
  const authToken = getCookie(authKeys.authToken);
  const urlFetchOpportunities = authToken
    ? apiConfig.routes.assets.opportunities
    : apiConfig.routes.assets.opportunitiesPublic;

  const { data } = await api.get<Paginated<AssetOpportunity>>(
    urlFetchOpportunities,
    { params }
  );
  return data.data;
};

export const useGetAssetsOpportunities = (
  params?: GetAssetsOpportunitiesParams
) =>
  useQuery({
    queryKey: ['assets', 'opportunities', { ...params }],
    queryFn: () => getAssetsOpportunities(params),
  });

type GetAssetsOpportunitiesParams = {
  page?: number;
  limit?: number;
};
